import { render, staticRenderFns } from "./IdTagPairedLabel.vue?vue&type=template&id=b027e510&scoped=true&"
import script from "./IdTagPairedLabel.vue?vue&type=script&lang=ts&"
export * from "./IdTagPairedLabel.vue?vue&type=script&lang=ts&"
import style0 from "./IdTagPairedLabel.vue?vue&type=style&index=0&id=b027e510&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b027e510",
  null
  
)

export default component.exports